__turbopack_context__.v({
  "divider": "switcher-divider-module__u6gR2G__divider",
});
